import { theme } from 'styles/theme'

export const BirthDateInputSXProps = {
  '& .MuiPickersInputBase-root': {
    height: '44px',
    paddingLeft: 0,
    '&:not(.Mui-focused):not(.Mui-error) .MuiPickersOutlinedInput-notchedOutline':
      {
        borderColor: 'transparent'
      }
  },
  '& .MuiPickersInputBase-sectionsContainer': {
    padding: '0 0 1px 14px',
    ...theme.typography.bodyMRegular
  },
  lineHeight: '16px',
  borderRadius: '12px',
  border: `1px solid ${theme.palette.surface.secondary}`,
  boxSizing: 'border-box',
  width: '100%',
  backgroundColor: theme.palette.surface.default
}

export const BirthDateInputErrorSXProps = {
  backgroundColor: '#ffeded'
}
